import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetStagesetStarters as GetStagesetStartersQuery,
    GetStagesetStarters_stagesetStarters as StagesetStarters,
} from 'nutshell-graphql-types';

import {DEFAULT_CATEGORIES} from '../../home/consts';
import type {StagesetStarterCategory} from '../../home/types';

import GET_STAGESET_STARTERS from '../queries/get-stageset-starters.graphql';

export const useGetStagesetStarters = (): {
    categories: StagesetStarterCategory[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetStagesetStartersQuery, Record<any, any>>(
        GET_STAGESET_STARTERS
    );

    const stagesetStarters = data ? data.stagesetStarters : null;

    const categories = stagesetStarters && getCategoriesFromStagesetStarters(stagesetStarters);
    const allCategories = categories ? [...DEFAULT_CATEGORIES, ...categories] : [];

    return {
        categories: allCategories,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};

function getCategoriesFromStagesetStarters(
    stagesetStarters: StagesetStarters[]
): StagesetStarterCategory[] {
    return stagesetStarters.map((stagesetStarter, index) => {
        return {
            id: stagesetStarter.type,
            title: stagesetStarter.name,
            // the first one should have a header
            label: index === 0 ? 'Templates' : undefined,
            collection: [
                {
                    type: stagesetStarter.type,
                    name: stagesetStarter.name,
                    description: stagesetStarter.description,
                },
            ],
        };
    });
}
